import PositionCategoryMarginsList from "./PositionCategoryMarginsList";

export default PositionCategoryMarginsList;
